import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-white border-t border-gray-200 py-4 text-center text-sm text-gray-600">
            <div className="container mx-auto px-4">
                <p>
                    &copy; {new Date().getFullYear()} Zumale Technologies LLP. All rights reserved.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
